import lang from '@/lang/middleware/pages/privacy';

export default async ({ $api, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $api(`privacy/policies`).then(privacyPolicy => {
    const description = store.$i18n.t('description');
    const title = store.$i18n.t('title');
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('privacyPolicy/set', privacyPolicy);
  });
};
